import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailItemValueContainer = styled.div<React.CSSProperties>`
  width: ${540 * Screen.widthRatio}px;
`;

export default DetailItemValueContainer;
